import React, { useEffect, useState } from 'react';
import CreateEmployeeModal from '../../component/employee/CreateEmployeeModal';
import EmployeeListTable from '../../component/employee/EmployeeListTable';
import EmployeeResponse from '../../model/Employee.model';
import EmployeeService from '../../service/employee-service/Employee.service';
import { Spinner } from '@radix-ui/themes';

const EmployeePage: React.FC = () => {
  const [employeeList, setEmployeeList] = useState<EmployeeResponse[]>([]);
  const [loading, setLoading] = useState<boolean>(false);

  const fetchEmployeeList = async () => {
    try {
      setLoading(true);
      const data = await EmployeeService.getEmployeeList();
      setEmployeeList(data);
    } catch (error) {
      console.error('Error fetching employee:', error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchEmployeeList();
  }, []);

  return (
    <div className="p-4 max-h-screen">
      <div className="flex justify-end mb-4">
        <CreateEmployeeModal onSuccess={fetchEmployeeList} />
      </div>
      {loading ? (
        <div className="flex justify-center items-center h-64">
          {' '}
          {/* Cài đặt kích thước cho phần loading */}
          <Spinner /> {/* Spinner */}
        </div>
      ) : (
        <EmployeeListTable
          employeeList={employeeList}
          onSuccess={fetchEmployeeList}
        />
      )}
    </div>
  );
};

export default EmployeePage;
